/**
 * Menu Drawer Submenu Animation
 * Auto-height with scrollHeight approach for smooth, adaptive animations
 */

class MenuDrawerAnimation {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    // Find all details elements that contain submenus
    const detailsElements = document.querySelectorAll('details:has(.menu-drawer__submenu):not(#Details-menu-drawer-container)');
    
    detailsElements.forEach(details => {
      const submenu = details.querySelector('.menu-drawer__submenu');
      if (!submenu) return;

      // Store the current height before any changes
      let currentHeight = 0;

      // Listen for click on summary to capture height before toggle
      const summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (event) => {
          if (details.hasAttribute('open')) {
            // About to close - capture current height and prevent default
            currentHeight = submenu.scrollHeight;
            
            // Prevent the default details behavior temporarily
            event.preventDefault();
            
            // Manually handle the close animation
            this.closeSubmenu(submenu, currentHeight);
            
            // Remove the open attribute after a short delay
            setTimeout(() => {
              details.removeAttribute('open');
            }, 10);
          }
        });
      }

      // Listen for the toggle event
      details.addEventListener('toggle', (event) => {
        this.handleToggle(event.target, submenu, currentHeight);
      });
    });
  }

  handleToggle(details, submenu, capturedHeight = 0) {
    const isOpen = details.hasAttribute('open');
    
    // Only handle opening - closing is handled in the click event
    if (isOpen) {
      this.openSubmenu(submenu);
    }
  }

  openSubmenu(submenu) {    
    // First, temporarily set height to auto to get the full content height
    submenu.style.height = 'auto';
    submenu.style.overflow = 'hidden';
    
    // Get the natural height when fully expanded
    const height = submenu.scrollHeight;
    
    // Now set height to 0 for the animation
    submenu.style.height = '0px';
    
    // Use requestAnimationFrame to ensure the height is set before animating
    requestAnimationFrame(() => {
      // Animate to the full height
      submenu.style.height = height + 'px';
      
      // Listen for transition end to reset height to auto
      submenu.addEventListener('transitionend', () => {
        submenu.style.height = 'auto'; // Reset for flexibility
        submenu.style.overflow = '';
      }, { once: true });
    });
  }

  closeSubmenu(submenu, capturedHeight) {
    // Use the captured height if available, otherwise fall back to scrollHeight
    const height = capturedHeight > 0 ? capturedHeight : submenu.scrollHeight;
    
    // Ensure overflow is hidden and set the explicit height
    submenu.style.overflow = 'hidden';
    submenu.style.height = height + 'px';
        
    // Force a reflow to ensure the height is applied
    submenu.offsetHeight;
    
    // Use requestAnimationFrame to ensure the height is set before animating to 0
    requestAnimationFrame(() => {
      // Animate to 0
      submenu.style.height = '0px';
      
      // Listen for transition end to clean up
      submenu.addEventListener('transitionend', () => {
        submenu.style.height = '';
        submenu.style.overflow = '';
      }, { once: true });
    });
  }
}

// Initialize the animation handler
new MenuDrawerAnimation();
